  $(document).ready(function(){
    $('#sign-up').form({
        on: 'blur',
         inline : true, 
        fields: {
            email: {
                identifier: 'email',
                rules: [{
                    type: 'empty',
                    prompt: 'Check your Email ID and try again.'
                }]
            }          
        }
    });
});


$(document).ready(function(){

    $('#set-up').form({
        on: 'blur',
         inline : true, 
        fields: {
            name: {
                identifier: 'name',
                rules: [{
                    type: 'empty',
                    prompt: 'Please avoid Initials'
                }]
            },
            number: {
                identifier: 'number',
                rules: [{
                    type: 'empty',
                    prompt: 'Please check your phone number'
                }]
            },
            code: {
                identifier: 'code',
                rules: [{
                    type: 'empty',
                    prompt: 'Please check the referral code'
                }]
            }             
        }
    });
    
});


$(document).ready(function(){
    $('#sign-in').form({
        on: 'blur',
         inline : true, 
        fields: {
            email: {
                identifier: 'email',
                rules: [{
                    type: 'empty',
                    prompt: 'Check your Email ID and try again.'
                }]
            }          
        }
    });
});


$(document).ready(function(){

    $('#signin-second').form({
        on: 'blur',
         inline : true, 
        fields: {
            email: {
                identifier: 'email',
                rules: [{
                    type: 'empty',
                    prompt: 'Check your Email ID and try again.'
                }]
            },
            password: {
                identifier: 'password',
                rules: [{
                    type: 'empty',
                    prompt: 'Please check your password and try again'
                }]
            }                      
        }
    });
    
});


$(document).ready(function(){

    $('#create-account').form({
        on: 'blur',
         inline : true, 
        fields: {
            email: {
                identifier: 'email',
                rules: [{
                    type: 'empty',
                    prompt: 'Check your Email ID and try again.'
                }]
            },
            password: {
                identifier: 'password',
                rules: [{
                    type: 'empty',
                    prompt: 'Please check your password and try again'
                }]
            }                      
        }
    });
    
});


